module.exports = __webpack_public_path__ + "img/scantop.d5cb4b2d.jpg";